// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdownContainer_vPjnV {
  position: relative;
  width: 100%;
  background-color: var(--f4-background);
  border-radius: 6px;
  display: flex;
  flex-direction: column;
}

.dropdownButton_CATd9 {
  width: 100%;
  padding: 14px 12px;
  border: none;
  background: transparent;
  color: #333;
  font-size: 0.85rem;
  text-align: left;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 1.5;
  background-color: transparent;
  border-radius: 6px;
  outline: none;
  box-shadow: none;
  transition: background 0.2s;
}

.dropdownButton_CATd9:hover {
  background-color: #eaeaea;
}

.arrow_bPKr_ {
  font-size: 0.75rem;
  color: #888;
  width: 12px;
  height: 12px;
  margin-left: 8px;
  flex-shrink: 0;
}

.dropdownList_VqtO8 {
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  right: 0;
  background-color: var(--f4-background);
  border-radius: 6px;
  box-shadow: 0 4px 8px var(--_0000001a-shadow);
  list-style: none;
  padding: 5px 0;
  margin: 0;
  max-height: 200px;
  overflow-y: auto;
  z-index: 9999;
  border: none;
}

.dropdownItem_YGedS {
  padding: 8px 12px;
  font-size: 0.85rem;
  color: #333;
  cursor: pointer;
  white-space: nowrap;
  border-radius: 6px;
  background-color: transparent;
  transition: background 0.2s;
}

.dropdownItem_YGedS:hover {
  background-color: #eaeaea;
}
`, "",{"version":3,"sources":["webpack://./src/factura-customizer/components/Dropdown/Dropdown.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,sCAAsC;EACtC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,sCAAsC;EACtC,kBAAkB;EAClB,6CAA6C;EAC7C,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".dropdownContainer {\n  position: relative;\n  width: 100%;\n  background-color: var(--f4-background);\n  border-radius: 6px;\n  display: flex;\n  flex-direction: column;\n}\n\n.dropdownButton {\n  width: 100%;\n  padding: 14px 12px;\n  border: none;\n  background: transparent;\n  color: #333;\n  font-size: 0.85rem;\n  text-align: left;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  line-height: 1.5;\n  background-color: transparent;\n  border-radius: 6px;\n  outline: none;\n  box-shadow: none;\n  transition: background 0.2s;\n}\n\n.dropdownButton:hover {\n  background-color: #eaeaea;\n}\n\n.arrow {\n  font-size: 0.75rem;\n  color: #888;\n  width: 12px;\n  height: 12px;\n  margin-left: 8px;\n  flex-shrink: 0;\n}\n\n.dropdownList {\n  position: absolute;\n  top: calc(100% + 2px);\n  left: 0;\n  right: 0;\n  background-color: var(--f4-background);\n  border-radius: 6px;\n  box-shadow: 0 4px 8px var(--_0000001a-shadow);\n  list-style: none;\n  padding: 5px 0;\n  margin: 0;\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 9999;\n  border: none;\n}\n\n.dropdownItem {\n  padding: 8px 12px;\n  font-size: 0.85rem;\n  color: #333;\n  cursor: pointer;\n  white-space: nowrap;\n  border-radius: 6px;\n  background-color: transparent;\n  transition: background 0.2s;\n}\n\n.dropdownItem:hover {\n  background-color: #eaeaea;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdownContainer": `dropdownContainer_vPjnV`,
	"dropdownButton": `dropdownButton_CATd9`,
	"arrow": `arrow_bPKr_`,
	"dropdownList": `dropdownList_VqtO8`,
	"dropdownItem": `dropdownItem_YGedS`
};
export default ___CSS_LOADER_EXPORT___;
